import state from "./state";

const getters = Object.keys(state).reduce((getters, key) => {
	getters[key] = (state) => state[key];
	return getters;
}, {});

const customGetter = {
	...getters,
}

export default customGetter;